import * as Utils from '../../../utils';
import { useTranslation } from 'react-i18next';
import {
    Grid,
} from '@material-ui/core'
import React, { useEffect } from 'react';
import Select from '../../../../common/components/UI/Select/ReactSelect'

/**
 * @typedef {{
 *  name: string,
 * }} IBillboardAction
 * @param {{
 *  classes: *,
 *  billboardActions: IBillboardAction[],
 *  selectedActionIndex: number,
 *  t: *,
 *  sidePanelData: *
 * }} param0 
 */
function RequestSelectionStep({ classes, billboardActions, selectedActionIndex, sidePanelData, onChange }) {
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'billboard'});
    const validBillboardActions = Utils.getValidManagerSettings(billboardActions, sidePanelData.shifts);

    useEffect(() => {
        onChange(billboardActions[selectedActionIndex]);
    }, [selectedActionIndex])
    
    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Select
                    labelText={t('selectRequestTypeHeader')}
                    placeholder={t('selectRequestType')}
                    value={billboardActions[selectedActionIndex]}
                    options={validBillboardActions}
                    onChange={(event, value) => onChange(value)}
                    selectWrapperClass={classes.selectWrapper}
                />
            </Grid>
        </Grid>
    );
}

export default RequestSelectionStep;